<script setup>
import Header from '../components/global/Header.vue'
import Footer from '../components/global/Footer.vue'
</script>

<template>
    <Header />
    <main class="relative z-20 lg:mb-48">
        <router-view v-slot="{ Component }">
            <component :is="Component"/>
        </router-view>
    </main>
    <Footer />
</template>